import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import ArrowBack from "../../common/images-new/arrow-back-black-icon.svg";
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import Comment from "../../components/LikeComment/Comment";
import AvatarGroup from "../../components/LikeComment/AvatarGroup";
import LikeComment from "../../components/LikeComment/LikeComment";
import PageWrapper from "../PageWrapper";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import { useParams } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { apiUrl, serverUrl } from "../../components/Helpers/Config";
import {
  getProfilePic,
  convertDate,
  addAttribute,
} from "../../components/Helpers/Common";
import readingTime from "reading-time";
import CommentInput from "../../components/LikeComment/CommentInput";
import { staticFiles } from "../../components/Helpers/Static";
import {
  ActiveIconColor,
  BgWhite,
  ButtonCommonTop,
  ButtonCommonTopNew,
  Card,
  DivBadge,
  TextGray,
} from "../Theme";
import { MdDescription, MdKeyboardArrowLeft } from "react-icons/md";
import { tokenAuthorize } from "../../components/Helpers/Common";
import JournalHashtag from "../../components/Button/JournalHashtag";
import ButtonCommon from "../../components/Button/ButtonCommon";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { Loading } from "../../components/Helpers/Common";
import Swal from "sweetalert2";
import { BiLeftArrowAlt } from "react-icons/bi";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { FaRegCommentDots } from "react-icons/fa";
import ChatInput from "../../components/LikeComment/ChatInput";
import SortToggle from "../../components/Button/SortToggle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { BsArrowLeft } from "react-icons/bs";
import RichContent from "../../components/Editor/RichContent";

const FILE_UPLOAD = staticFiles.fileUpload;
const NO_IMAGE = staticFiles.noImage;

const PostView = () => {
  const history = useHistory();
  const location = useLocation();

  const { postId } = useParams();
  const userId = localStorage.getItem("user_id");
  const userProfile = useSelector((state) => state.auth.user);

  const profile = {
    name: userProfile ? userProfile.fullname : "",
    photo: userProfile ? userProfile.photo : hmenu_user,
  };

  // let list = [{profilePic: profile.photo, username: profile.name, daysAgo:3, comment: commentText,
  //                     numLikes:14, numComments:5}]

  const [commentList, setCommentList] = useState([]);
  const [commentLatest, setCommentLatest] = useState([]);
  const [comment, setComment] = useState("");
  const [likesList, setLikesList] = useState([]);
  const [postData, setPostData] = useState({});
  const [sortOrder, setsortOrder] = useState("desc");
  const [toggleComment, setToggleComment] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [offsetComments, setOffsetComments] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [sortOrderInitial, setsortOrderInitial] = useState("desc");

  useEffect(() => {
    getPost(postId);
    getLikes(postId);
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
      // setsortOrder(str)
    }
    setsortOrder(str);
    setsortOrderInitial(str);
    // getComments(postId, str)
    let reflectionData = { reflection_id: postId };
    axios
      .post(serverUrl.ReflectionsReads, reflectionData)
      .then((resp) => {
        if (resp.status === 200) {
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  }, []);

  const goBack = () => {
    // const prevPage = (location.state && location.state.src) ? location.state.src : '/';
    // const tabId = (location.state && location.state.tabId) ? location.state.tabId : 0;

    // history.push(prevPage, { tabId })
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/"); // fallback to home
    }
  };

  const getPost = (postId) => {
    return axios
      .get(serverUrl.ReflectionPost + "/" + postId)
      .then((resp) => {
        if (resp.status === 200) {
          let postData = resp.data.post;
          setPostData(postData);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        if (err.response && err.response.status === 404) {
          history.push("/post-not-found");
        } else {
          console.log(err);
        }
      });
  };

  const getLikes = (postId) => {
    return axios
      .get(apiUrl + "likes/" + postId)
      .then((resp) => {
        if (resp.status === 200) {
          let likesList = resp.data.results;
          setLikesList(likesList);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const loadMoreComments = () => {
    setLoadingComments(true);
    let count = offsetComments + 10;
    setOffsetComments(offsetComments + 10);
    getComments(sortOrder, count);
  };

  const getComments = (str, offset) => {
    return axios
      .get(
        apiUrl +
        "comments/" +
        postId +
        "?sort_order=" +
        sortOrderInitial +
        "&limit=10&offset=" +
        offset
      )
      .then((resp) => {
        if (resp.status === 200) {
          let data = [];
          data = resp.data.results;
          if (resp.data.results?.length > 9) {
            setHasMoreComments(true);
          } else {
            setHasMoreComments(false);
          }
          data = [...data, ...commentList];
          if (sortOrder == "asc") {
            const ascSortedData = data
              ?.slice()
              .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
            setCommentList(ascSortedData);
          }
          if (sortOrder == "desc") {
            const descSortedData = data
              ?.slice()
              .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            setCommentList(descSortedData);
          }
          setLoadingComments(false);
          // let newCommentList = resp.data.results
          // setCommentList(newCommentList)
          // if (newCommentList?.length > 0) {
          //     if (str == "desc") {
          //         setCommentLatest([newCommentList[0]])
          //     }
          //     if (str == "asc") {
          //         setCommentLatest([newCommentList[newCommentList?.length - 1]])
          //     }
          // }
        } else {
          setLoadingComments(false);
        }
      })
      .catch((err) => {
        setLoadingComments(false);
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const likePost = (isLiked) => {
    return axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: postId,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          getPost(postId);
          getLikes(postId);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const commentPost = (commentText, isPublic) => {
    return axios
      .post(serverUrl.ReflectionPost + "/comment", {
        reflection_id: postId,
        comment: commentText,
        visibility: isPublic,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let str = sortOrder;
          if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder");
            setsortOrder(str);
          }
          postData.comments_count = postData.comments_count + 1;
          let object = [
            {
              photo: userProfile?.photo,
              fullname: userProfile?.fullname,
              created_on: new Date(),
              guid: userProfile?.guid,
              reflection_comment_id: resp.data?.reflection_comment_id,
              user_id: resp.data?.user_id,
              comments: commentText,
              visibility: isPublic,
            },
          ];
          if (toggleComment == false) {
            setCommentList([]);
            setOffsetComments(0);
            setToggleComment(true);
            getComments(str, offsetComments);
          } else {
            if (str == "desc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...object, ...commentList]);
              }
            }
            if (str == "asc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...commentList, ...object]);
              }
            }
          }
          setComment("");
          // getComments(postId, str)
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const deleteComment = (commentId) => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure you want to delete this comment?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(serverUrl.Comment2 + "/" + commentId)
          .then((resp) => {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Comment has been deleted",
              icon: "success",
            });
            if (resp.status === 200) {
              postData.comments_count = postData.comments_count - 1;
              let str = sortOrder;
              if (localStorage.getItem("sortOrder") != undefined) {
                str = localStorage.getItem("sortOrder");
                setsortOrder(str);
              }
              const data = commentList.filter(
                (item) => item.reflection_comment_id !== commentId
              );
              setCommentList(data);
              // getComments(str, offsetComments)
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            Swal.fire({
              heightAuto: false,
              title: "Error",
              text: "Cannot delete the comment",
              icon: "error",
            });
          });
      }
    });
  };

  const handleSort = (str) => {
    setsortOrder(str);
    localStorage.setItem("sortOrder", str);
    if (str == "asc") {
      const ascSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
      setCommentList(ascSortedData);
    }
    if (str == "desc") {
      const descSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCommentList(descSortedData);
    }
    // getComments(postId, str)
  };

  const handleCommentClick = () => {
    setToggleComment(!toggleComment);
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
      setsortOrder(str);
    }
    if (!toggleComment === false) {
      // dispatch(getShowcases());
      getPost(postId);
      setOffsetComments(0);
      setHasMoreComments(false);
      setsortOrderInitial(str);
      setCommentList([]);
    }
    if (!toggleComment === true) {
      setLoadingComments(true);
      getComments(str, offsetComments);
    }
    // if (!toggleComment === false) {
    //     setsortOrder("desc")
    // }
    // getComments(str)
  };
  const minutesRead = postData?.reflection_content
    ? readingTime(postData.reflection_content).text
    : null;

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  const [isPublic, setIsPublic] = useState(true);
  const handlePrivatePublic = (data) => {
    if (isPublic != data) {
      setIsPublic(!isPublic);
    }
  };

  return (
    <PageWrapper>
      <div className="border20px shadow-md overflow-hidden cardBackgroundColor pt-6 relative">
        <div className="flex flex-col px-5 md:px-28 lg:px-36 mb-4 items-start">
          <div className="flex  items-center w-full">
            {/* <MdKeyboardArrowLeft className='w-10 h-10 cursor-pointer back-icon' onClick={goBack} /> */}

            {/* <ButtonCommonTopNew
              className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
              onClick={goBack}
            >
              <BiLeftArrowAlt className="w-5 h-5" />
              <h1 className="text-xs lg:text-sm">Back</h1>
            </ButtonCommonTopNew> */}
            <div
              className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
              onClick={goBack}
            >
              <KeyboardBackspaceIcon
                style={{ fontSize: "28px" }}
                className=" primaryIcon"
              />
              <h1 className="text-lg blueColor font-semibold">Back</h1>
            </div>
            <p className="text-xl font-bold break-words flex-1 text-center">
              {postData?.reflection_title}
            </p>
          </div>
          <div className="flex w-full flex-row lg:flex-row pt-4 mb-2 items-center relative ">
            <img
              className="h-10 w-10 mr-2 rounded-full"
              src={getProfilePic(postData.profile_pic)}
              alt="profile"
            ></img>
            <div className="flex flex-col mr-10 text-left">
              <div className="flex items-center ">
                {/* by */}
                <Link
                  to={"/profile/" + postData.guid}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base font-semibold break-words nav-navigate"
                >
                  <ActiveIconColor className="">
                    {postData.username}
                  </ActiveIconColor>
                </Link>
              </div>
              <TextGray className="text-sm font-normal flex items-center gap-1">
                {moment
                  .utc(postData?.reflection_updated_on)
                  .local()
                  .startOf("seconds")
                  .fromNow()}
                <span>
                  ({formatModernDate(postData?.reflection_updated_on)})
                </span>{" "}
                - {minutesRead}
                <span className="flex items-center gap-0">
                  {postData?.reflection_address && (
                    <>
                      <LocationOnIcon
                        className="text-red-600 "
                        style={{ fontSize: "18px" }}
                      />
                      {postData.reflection_address}
                    </>
                  )}
                </span>
              </TextGray>
            </div>
          </div>
          <div className="flex flex-row w-full flex-wrap gap-2 mb-2">
            {postData.hashtag &&
              postData.hashtag.map((hashtag, index) => (
                <JournalHashtag key={index} text={hashtag} color="blue" />
              ))}
            {postData.values &&
              postData.values.map((value, index) => (
                <ButtonHashtag key={index} text={value.value} color="orange" />
              ))}
            {postData.events &&
              postData.events.map((events, index) => (
                <ButtonHashtag key={index} text={events.value} color="green" />
              ))}
            {postData.courses &&
              postData.courses.map((course, index) => (
                <ButtonHashtag key={index} text={course.value} color="red" />
              ))}
            {postData.groups &&
              postData.groups.map((group, index) => (
                <JournalHashtag key={index} text={group.value} color="blue" />
              ))}
          </div>

          {postData.docs && (
            <div className="flex flex-wrap w-full gap-2">
              {postData.docs.map((item, idx) => {
                let itemName = item ? item : null;
                if (itemName) {
                  const itemUrl = itemName;
                  const lastSlash = itemName.lastIndexOf("/");

                  if (lastSlash !== -1) {
                    itemName = itemName.substr(
                      lastSlash + 1,
                      itemName.length - lastSlash - 1
                    );
                    itemName = itemName.includes("-")
                      ? itemName.substring(itemName.indexOf("-") + 1)
                      : itemName;
                  }
                  return (
                    <>
                      {/* <div key={idx} className='flex flex-row items-center gap-1 "'>
                                                <MdDescription className='w-6 h-6 blueColor' />
                                                <a
                                                    href={itemUrl}
                                                    target="_blank" rel="noopener noreferrer"
                                                    className='hover:text-gray-800 cursor-pointer underline break-words nav-navigate'
                                                >
                                                    <TextGray className="underline">{itemName}</TextGray>
                                                </a>
                                            </div> */}
                      <DivBadge
                        key={idx}
                        className="flex flex-row items-center rounded-lg px-2 justify-center w-max"
                      >
                        <MdDescription className="w-5 h-5 text-white" />
                        <a
                          href={itemUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex text-sm p-1 nav-navigate"
                        >
                          <div className=" text-white">{itemName}</div>
                        </a>
                      </DivBadge>
                    </>
                  );
                }

                return null;
              })}
            </div>
          )}
          {/* Post Body */}
          {postData.reflection_image &&
            postData.reflection_image.length > 0 && (
              <img
                className="border20px object-contain max-w-full h-auto pt-2 mx-auto"
                src={postData.reflection_image}
                alt={postData.reflection_title}
                onError={(e) => {
                  e.target.src = NO_IMAGE;
                }}
              />
            )}
        </div>
        <RichContent
          className="px-5 md:px-28 lg:px-36 mt-2 break-words w-full"
          content={addAttribute(postData.reflection_content)}
        />

        {/* Likes and comments */}
        <hr className="self-center w-full rm mb-4 mt-2 px-5 md:px-10" />

        <div className="px-5 md:px-28 lg:px-36 mb-3">
          {/* <CommentInput
                        comment={comment}
                        setComment={setComment}
                        commentPost={commentPost}
                        profilePhoto={profile.photo}

                        
                    /> */}
          <ChatInput
            message={comment}
            setMessage={setComment}
            addComment={commentPost}
            isPublic={isPublic}
            handlePrivatePublic={handlePrivatePublic}
          />
        </div>
        <div className="flex flex-1  md:flex-row  px-5  md:px-28 lg:px-36 rm mb-3">
          {likesList?.length > 0 ? <AvatarGroup likesList={likesList} /> : null}
          <div className="flex items-center  lightColor text-sm">
            <div
              className="flex items-center mr-3 gap-0.5 cursor-pointer"
              onClick={() => likePost(parseInt(postData.like) === 1 ? 0 : 1)}
            >
              {parseInt(postData?.like) ? (
                <ThumbUpAltIcon
                  fontSize="small"
                  className={`likeIcon primaryIcon`}
                />
              ) : (
                <ThumbUpOffAltIcon
                  fontSize="small"
                  className={`likeIcon secondaryIcon`}
                />
              )}
              <span className="lightColor">{likesList?.length} Likes</span>
            </div>
            <div
              className="flex items-center gap-0.5 cursor-pointer"
              onClick={handleCommentClick}
            >
              <FaRegCommentDots className={`w-4 h-4 secondaryIcon`} />
              {/* <SmsOutlinedIcon fontSize="small" className="likeIcon" /> */}
              <span className="lightColor">
                {postData?.comments_count} Comments
              </span>
            </div>
          </div>
        </div>
        <hr className="self-center w-full px-5 md:px-28 lg:px-36  rm mt-2 " />

        {/* Comment */}

        {/* <TextGray className="flex justify-center my-5 underline cursor-pointer md:my-10 hover:text-gray-800 rm">
                    see all comments {commentList.length}
                </TextGray> */}

        <div className="p-0 m-0 border20pxbottom backgroundColor8  px-5 md:px-28 lg:px-36 pb-3">
          <div className="relative items-center  rm">
            {commentList.length != 0 && (
              <>
                <div className="flex flex-col sm:flex-row items-center justify-between mb-2 pt-3">
                  <p className="text-base font-semibold blackColor">
                    Comments ({postData?.comments_count})
                  </p>
                  {toggleComment == true && (
                    <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                  )}
                </div>
              </>
            )}
            <div style={{ marginTop: loadingComments === false ? "" : "" }}>
              {toggleComment === true ? (
                commentList &&
                commentList.map((comment, index) => (
                  <Comment
                    key={index}
                    order={index}
                    profilePic={comment.photo}
                    username={comment.fullname}
                    createdOn={comment.created_on}
                    comment={comment.comments}
                    handleDelete={() =>
                      deleteComment(comment.reflection_comment_id)
                    }
                    userId={comment.user_id}
                    guID={comment.guid}
                    isPrivate={comment.visibility}
                  // numLikes = {comment.numLikes}
                  // numComments = {comment.numComments}
                  />
                ))
              ) : (
                <>
                  {postData?.latest_comment ? (
                    <Comment
                      // key={index}
                      // order={index}
                      profilePic={postData?.latest_comment?.photo}
                      username={postData?.latest_comment?.fullname}
                      createdOn={postData?.latest_comment?.created_on}
                      comment={postData?.latest_comment?.comment}
                      // handleDelete={() => deleteComment(post?.latest_comment?.reflection_comment_id)}
                      deleteView={true}
                      // userId={post?.latest_comment?.user_id}
                      // isView={isView}
                      guID={postData?.latest_comment?.user_guid}
                      isPrivate={postData?.latest_comment?.visibility}
                    />
                  ) : (
                    <p className="pt-3">There is no comment yet.</p>
                  )}{" "}
                </>
              )}
            </div>
          </div>
          {loadingComments && (
            <div className="grid grid-cols-1 h-10 py-3">
              <div className="justify-center justify-self-center">
                <Loading active={loadingComments} />
              </div>
            </div>
          )}
          {toggleComment && hasMoreComments && (
            <div className="grid grid-cols-1 h-14 pt-3">
              <div className="justify-center justify-self-center">
                <ButtonCommonTopNew
                  className="flex items-center justify-center border p-2 rounded-lg cursor-pointer font-bold text-sm"
                  onClick={loadMoreComments}
                >
                  Load more
                </ButtonCommonTopNew>
              </div>
            </div>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default PostView;
